import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {SearchCategoryInfoAggregations} from 'src/app/types/SearchCategoryInfoAggregations';
import {SearchResultsDescription} from 'src/app/types/SearchResultsDescription';
import {SearchResultContent} from '../../../../../../types/SearchResultContent';

@Component({
  selector: 'app-search-long-description-v2',
  templateUrl: './search-long-description-v2.component.html',
  styleUrls: ['./search-long-description-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchLongDescriptionV2Component {
  count = input<number>(0);
  name = input<string>('');
  pluralName = input<string>('');
  place = input<string>('');
  data = input<SearchCategoryInfoAggregations>();
  searchDescription = input<SearchResultsDescription>();
  searchResultContent = input<SearchResultContent>();

  public totalNumberOfRatings = computed(() => {
    return this.data() && this.data().topRatedCareProviderUnits && this.data().topRatedCareProviderUnits.length > 0
      ? this.data()
          .topRatedCareProviderUnits.map((item) => item.basedOnNumberOfRatings)
          .reduce((prev, curr) => prev + curr, 0)
      : 0;
  });
}
